/**
 * CalendarDay 컴포넌트
 *
 * 달력의 개별 날짜 셀을 표시
 * - 날짜 숫자
 * - 거래가 있으면 점(dot) 표시 (수입: 초록색, 지출: 빨간색)
 * - 현재 월 외의 날짜는 흐리게 표시
 * - 오늘 날짜는 강조 표시
 */

import type { Transaction } from '@/domains/transaction/types/Transaction'

interface CalendarDayProps {
  date: Date
  transactions: Transaction[]
  isCurrentMonth: boolean
  isToday: boolean
  onClick: () => void
}

export function CalendarDay({
  date,
  transactions,
  isCurrentMonth,
  isToday,
  onClick,
}: CalendarDayProps) {
  const hasIncome = transactions.some((t) => t.type === 'income')
  const hasExpense = transactions.some((t) => t.type === 'expense')

  return (
    <button
      onClick={onClick}
      className={`
        min-h-16 p-2 border border-gray-200 dark:border-gray-700
        flex flex-col items-center justify-start
        hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors
        ${!isCurrentMonth ? 'text-gray-400 dark:text-gray-600' : 'text-gray-900 dark:text-gray-100'}
        ${isToday ? 'bg-primary-50 dark:bg-primary-900/20 border-primary-500' : ''}
      `}
    >
      {/* 날짜 숫자 */}
      <span className={`text-sm ${isToday ? 'font-bold text-primary-600 dark:text-primary-400' : ''}`}>
        {date.getDate()}
      </span>

      {/* 거래 인디케이터 (점) */}
      {transactions.length > 0 && (
        <div className="flex gap-1 mt-1">
          {hasIncome && (
            <div className="w-1.5 h-1.5 rounded-full bg-income-fixed" title="수입" />
          )}
          {hasExpense && (
            <div className="w-1.5 h-1.5 rounded-full bg-expense-fixed" title="지출" />
          )}
        </div>
      )}
    </button>
  )
}
